import React from "react";
import styled, { keyframes } from "styled-components";
import * as Dialog from "@radix-ui/react-dialog";
import BasicButton from "../BasicButton/BasicButton";

const OpenButton = styled(BasicButton)`
  font-size: 1.25rem;
  padding: 8px 8px;
`;

const CloseButton = styled(BasicButton)`
  font-size: 1.25rem;
  padding: 8px 8px;
  width: fit-content;
  align-self: flex-end;
  margin-top: 1rem;
`;

function ZuckPlus({ hasPurchasedZuckPlus, setHasPurchasedZuckPlus }) {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <OpenButton>get zuck+</OpenButton>
      </Dialog.Trigger>
      <Dialog.Portal>
        <DialogOverlay />
        <DialogContent>
          <DialogTitle>zuck+</DialogTitle>
          <DialogMain>
            <DescriptionText>
              zuck+ is a cosmetic-only microtransaction that places a gold chain
              around your neck.
            </DescriptionText>
            <DescriptionText>
              it doesn't look very good because i spent about 8 minutes on it
            </DescriptionText>
            <DescriptionText>
              to purchase zuck+,{" "}
              <Link href="https://buymeacoffee.com/eieio">
                submit any payment here
              </Link>
              . Then check this box:
            </DescriptionText>
            <CheckboxHolder>
              <input
                style={{ width: "1.5rem", height: "1.5rem" }}
                id="zuck-plus-checkbox"
                type="checkbox"
                checked={hasPurchasedZuckPlus}
                onChange={(e) => {
                  setHasPurchasedZuckPlus(e.target.checked);
                }}
              />
              <CheckboxDescription htmlFor="zuck-plus-checkbox">
                i purchased zuck+
              </CheckboxDescription>
            </CheckboxHolder>
            <DescriptionText>
              remember that lying on the internet is a federal crime
            </DescriptionText>
          </DialogMain>
          <Dialog.Close asChild>
            <CloseButton>Close</CloseButton>
          </Dialog.Close>
        </DialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

const DialogOverlayAppear = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 0.6;
  }
`;

const ContentShow = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -48%) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
`;

const CheckboxHolder = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 350px;
  align-items: center;
  margin: 0 auto;
  margin-top: 1rem;
  width: 100%;
  gap: 1rem;
`;

const CheckboxDescription = styled.label`
  font-size: 1.25rem
  font-family: monospace;
  color: var(--color-indigo-900);
  margin: 0;

`;

const Link = styled.a`
  color: var(--color-indigo-900);
  text-decoration: underline;
`;

const DialogOverlay = styled(Dialog.Overlay)`
  position: fixed;
  inset: 0;
  background-color: var(--color-slate-900);
  animation: ${DialogOverlayAppear} 0.15s ease-in-out both;
`;

const DialogContent = styled(Dialog.Content)`
  background-color: var(--color-amber-200);
  border-radius: 8px;
  padding: 2rem;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  max-width: 500px;
  max-height: 85vh;
  overflow: auto;
  animation: ${ContentShow} 0.15s ease-in-out both;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const DialogMain = styled.div`
  font-size: 1rem;

  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
  font-family: monospace;
  color: var(--color-indigo-900);
`;

const DescriptionText = styled(Dialog.Description)`
  font-size: inherit;
  font-family: monospace;
  color: var(--color-indigo-900);
  margin: 0;
  margin-top: 1rem;
`;

const DialogTitle = styled(Dialog.Title)`
  font-size: 2rem;
  font-family: monospace;
  color: var(--color-indigo-900);
`;

export default ZuckPlus;
